import React, { Component } from 'react';
import { withStyles, Button, TextField, FormControl } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
// import LinearProgress from '@material-ui/core/LinearProgress';
import * as FuseActions from '../../../store/actions';
import * as Actions from '../users/store/actions/users.actions';
import { services } from '../../api/feathers';

const styles = () => ({
  root: {
    width: '100%',
  },
});

class JWTLoginTab extends Component {
  static evaluatePassword = (pwd = '') => {
    const hasUpper = /[A-Z]/.test(pwd);
    const hasLower = /[a-z]/.test(pwd);
    const hasNumber = /\d/.test(pwd);
    const hasSpecial = /[^A-Za-z0-9]/.test(pwd);

    // eslint-disable-next-line no-nested-ternary
    const lengthScore = pwd.length >= 10 ? 2 : pwd.length >= 8 ? 1 : 0;

    let score = 0;
    score += hasUpper ? 1 : 0;
    score += hasLower ? 1 : 0;
    score += hasNumber ? 1 : 0;
    score += hasSpecial ? 1 : 0;
    score += lengthScore;

    const percent = Math.min(100, Math.round((score / 5) * 100));

    let label = 'Fraca';
    if (percent >= 80) label = 'Excelente';
    else if (percent >= 60) label = 'Forte';
    else if (percent >= 40) label = 'Média';

    const valid = pwd.length >= 6 && hasUpper && hasLower && hasNumber;

    return {
      score: percent,
      label,
      valid,
      requirements: { upper: hasUpper, lower: hasLower, number: hasNumber },
    };
  };

  static getStrengthColor = (strength) => {
    if (strength.valid) return '#2e7d32';
    if (strength.score >= 40) return '#ef6c00';
    return '#b71c1c';
  };

  static preventPaste = (e) => {
    e.preventDefault();
  };

  static preventPasteKeys = (e) => {
    const key = e.key || '';
    if ((e.ctrlKey || e.metaKey) && key.toLowerCase() === 'v') {
      e.preventDefault();
    }
    if (e.shiftKey && key === 'Insert') {
      e.preventDefault();
    }
  };

  constructor() {
    super();
    this.state = {
      password: '',
      confirmPassword: '',
      passwordStrength: {
        score: 0,
        label: 'Fraca',
        valid: false,
        requirements: { upper: false, lower: false, number: false },
      },
    };
  }

  handleChange = (e) => {
    const change = {
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    };
    if (e.target.name === 'password') {
      const { value } = e.target;
      const strength = JWTLoginTab.evaluatePassword(value);
      this.setState({
        password: value,
        passwordStrength: strength,
      });
      return;
    }
    this.setState({ ...change });
  };

  handleMessage = (message, variant) => {
    const { showMessage } = this.props;
    showMessage({
      message, // text or html
      autoHideDuration: 6000, // ms
      anchorOrigin: {
        vertical: 'top', // top bottom
        horizontal: 'center', // left center right
      },
      variant, // success error info warning null
    });
  };

  onSubmit = (ev) => {
    ev.preventDefault();
    const { match } = this.props;
    const { userId, code } = match.params;
    const { confirmPassword, password, passwordStrength } = this.state;

    if (!password) {
      this.handleMessage('Informe a senha do usuário.', 'error');
      return false;
    }
    if (password.length < 6) {
      this.handleMessage(
        'A senha do usuário deve possuir no minimo 6 caracteres.',
        'error',
      );
      return false;
    }
    if (!passwordStrength.valid) {
      // eslint-disable-next-line max-len
      this.handleMessage(
        'A senha deve conter ao menos 1 letra maiúscula, 1 letra minúscula e 1 número. ' +
          'Caracteres especiais são permitidos.',
        'error',
      );
      return false;
    }
    if (password !== confirmPassword) {
      this.handleMessage(
        'A senha e a confirmação de senha devem ser iguais.',
        'error',
      );
      return false;
    }

    services.resetPassword
      .patch(userId, {
        password,
        code,
      })
      .then(() => {
        this.handleMessage('Senha salva com sucesso.', 'success');
      })
      .catch((error) => {
        if (error.message) {
          this.handleMessage(
            error.message === 'Código inválido.'
              ? 'Código de verificação inválido. Favor entrar em contato com o suporte técnico.'
              : error.message,
            'error',
          );
        } else {
          this.handleMessage('Erro ao salvar senha.', 'error');
        }
      });
    return true;
  };

  render() {
    const { classes } = this.props;
    const { password, confirmPassword, passwordStrength } = this.state;
    const strengthColor = JWTLoginTab.getStrengthColor(passwordStrength);
    return (
      <div className={classes.root}>
        <form
          onSubmit={this.onSubmit}
          className="flex flex-col justify-center w-full"
        >
          <FormControl
            style={{ marginTop: 15 }}
            className="flex flex-col justify-center w-full"
          >
            <TextField
              className="mb-16"
              onChange={this.handleChange}
              label="Nova Senha"
              autoFocus
              name="password"
              variant="outlined"
              type="password"
              value={password}
              error={!!password && !passwordStrength.valid}
              helperText={
                password ? (
                  <div style={{ marginTop: 4 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ flex: 1, marginRight: 8 }}>
                        <div
                          style={{
                            height: 8,
                            backgroundColor: '#e0e0e0',
                            borderRadius: 4,
                            overflow: 'hidden',
                          }}
                        >
                          <div
                            style={{
                              height: '100%',
                              width: `${passwordStrength.score}%`,
                              backgroundColor: strengthColor,
                              transition:
                                'width 0.3s ease, background-color 0.3s ease',
                            }}
                          />
                        </div>
                      </div>
                      <span
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: strengthColor,
                        }}
                      >
                        {`Força: ${passwordStrength.label}`}
                      </span>
                    </div>
                    <div style={{ fontSize: 12, marginTop: 6, color: '#666' }}>
                      A senha deve conter:
                      <span
                        style={{
                          marginLeft: 6,
                          color: passwordStrength.requirements.upper
                            ? '#2e7d32'
                            : '#d32f2f',
                          fontWeight: passwordStrength.requirements.upper
                            ? 'bold'
                            : 'normal',
                        }}
                      >
                        Maiúsculas (A-Z)
                      </span>
                      <span style={{ margin: '0 4px', color: '#666' }}>•</span>
                      <span
                        style={{
                          color: passwordStrength.requirements.lower
                            ? '#2e7d32'
                            : '#d32f2f',
                          fontWeight: passwordStrength.requirements.lower
                            ? 'bold'
                            : 'normal',
                        }}
                      >
                        Minúsculas (a-z)
                      </span>
                      <span style={{ margin: '0 4px', color: '#666' }}>•</span>
                      <span
                        style={{
                          color: passwordStrength.requirements.number
                            ? '#2e7d32'
                            : '#d32f2f',
                          fontWeight: passwordStrength.requirements.number
                            ? 'bold'
                            : 'normal',
                        }}
                      >
                        Números (0-9)
                      </span>
                      <div
                        style={{ fontSize: 11, marginTop: 2, color: '#888' }}
                      >
                        Caracteres especiais são permitidos (!@#$%&* etc.)
                      </div>
                    </div>
                  </div>
                ) : null
              }
            />
          </FormControl>

          <FormControl
            style={{ marginTop: 15 }}
            className="flex flex-col justify-center w-full"
          >
            <TextField
              className="mb-16"
              onChange={this.handleChange}
              label="Confirme sua senha"
              autoFocus
              name="confirmPassword"
              variant="outlined"
              type="password"
              value={confirmPassword}
              onPaste={JWTLoginTab.preventPaste}
              onDrop={JWTLoginTab.preventPaste}
              onKeyDown={JWTLoginTab.preventPasteKeys}
            />
          </FormControl>
          <Button
            style={{ marginTop: 15 }}
            type="submit"
            variant="contained"
            color="primary"
            className="w-full mx-auto mt-16 normal-case"
            aria-label="LOG IN"
            value="legacy"
          >
            Salvar Nova Senha sdads
          </Button>
        </form>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateUsers: Actions.updateUsers,
      showMessage: FuseActions.showMessage,
    },
    dispatch,
  );
}

export default withStyles(styles, { withTheme: true })(
  withRouter(connect(null, mapDispatchToProps)(JWTLoginTab)),
);
